import React from 'react';
import cx from 'classnames';
import { Star } from './Star/Star';
import styles from './RatingStars.module.css';
export const RatingStars = ({ className, icon: Icon = Star, iconClassName, activeClassName, inactiveClassName, count = 5, value = 0 }) => (React.createElement("div", { className: cx(styles.component, className) }, [...Array(count)].map((_, index) => {
    const diff = value - index;
    const starValue = diff > 0 ? Math.min(diff, 1) : 0;
    return (React.createElement(Icon, { className: cx(styles.icon, iconClassName), activeClassName: activeClassName, inactiveClassName: inactiveClassName, 
        // eslint-disable-next-line react/no-array-index-key
        key: `star-${index}-${starValue}`, value: starValue }));
})));
export default RatingStars;
//# sourceMappingURL=RatingStars.js.map